module.exports = __webpack_public_path__ + "static/media/sequencing-shadow.09a3455c.svg";